// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__230Nd","main":"index_main__2QlDL","collapseContent":"index_collapseContent__ECoEz"};